export default {"src":"/_next/static/media/shipping9.141babf5.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};